<div class="p-4 bg-white/50 backdrop-blur-md rounded-2xl shadow-sm border border-gray-100">
    <h2 class="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <i class="fa fa-plus-circle text-[#c19725]"></i>
        {{ isEditMode ? 'Update' : 'Add' }} Expense Type
    </h2>

    <form [formGroup]="expenseTypeForm" (ngSubmit)="saveExpenseType()"
        class="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
        <!-- Expense Type Name -->
        <div class="flex flex-col">
            <label class="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">Expense Type Name</label>
            <input type="text" formControlName="exty_name" placeholder="e.g., Staff Welfare, Office Supplies, Travel"
                class="p-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#c19725]/50 outline-none transition-all shadow-sm text-sm" />
        </div>

        <!-- Submit Button -->
        <div class="flex gap-2">
            <button type="submit" [disabled]="expenseTypeForm.invalid"
                class="px-8 py-3 bg-[#c19725] text-white font-bold rounded-xl shadow-lg hover:shadow-[#c19725]/40 hover:bg-[#a8821d] transition-all disabled:opacity-50 disabled:shadow-none whitespace-nowrap">
                {{ isEditMode ? 'Update Type' : 'Save Type' }}
            </button>

            <button *ngIf="isEditMode" type="button" (click)="resetForm()"
                class="px-8 py-3 bg-gray-100 text-gray-600 font-bold rounded-xl hover:bg-gray-200 transition-all">
                Cancel
            </button>
        </div>
    </form>

    <div class="mt-12">
        <h3 class="text-lg font-bold text-gray-800 mb-4">Existing Expense Types</h3>
        <div class="overflow-x-auto rounded-xl border border-gray-100">
            <table class="w-full text-left border-collapse">
                <thead class="bg-gray-50 uppercase text-[10px] font-bold text-gray-600">
                    <tr>
                        <th class="px-4 py-3 border-b border-gray-100">Sr. No.</th>
                        <th class="px-4 py-3 border-b border-gray-100">Expense Type Name</th>
                        <th class="px-4 py-3 border-b border-gray-100 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody class="text-xs text-gray-700 divide-y divide-gray-100">
                    <tr *ngFor="let type of pagedTypes; let i = index" class="hover:bg-gray-50/50 transition-colors">
                        <td class="px-4 py-3">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                        <td class="px-4 py-3 font-medium">{{ type.exty_name }}</td>
                        <td class="px-4 py-3 text-center">
                            <div class="flex items-center justify-center gap-3">
                                <button (click)="editType(type)" class="text-blue-500 hover:text-blue-700 transition"
                                    title="Edit">
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button (click)="deleteType(type.id)" class="text-red-500 hover:text-red-700 transition"
                                    title="Delete">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="pagedTypes.length === 0">
                        <td colspan="3" class="px-4 py-8 text-center text-gray-400">No expense types found.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div *ngIf="totalPages > 1" class="mt-4 flex justify-end gap-2">
            <button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"
                class="px-3 py-1 bg-white border border-gray-200 rounded-lg text-[10px] font-bold disabled:opacity-50 hover:bg-gray-50">
                PREV
            </button>
            <span class="px-3 py-1 text-[10px] font-bold flex items-center">
                PAGE {{ currentPage }} OF {{ totalPages }}
            </span>
            <button [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)"
                class="px-3 py-1 bg-white border border-gray-200 rounded-lg text-[10px] font-bold disabled:opacity-50 hover:bg-gray-50">
                NEXT
            </button>
        </div>
    </div>
</div>